import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-icon',
  components: {},
})
export default class DisplayFieldIcon extends mixins(AbstractDisplayField) {
  get icon(): string {
    const item = this.fieldConfig.valueToIcon?.find(item => item.value === this.value);
    return item?.icon || this.fieldConfig.defaultIcon || 'info';
  }

  get iconClass(): string[] {
    const item = this.fieldConfig.valueToIcon?.find(item => item.value === this.value);
    return [this.fieldConfig.iconClass].concat(
      item?.variant ? [`text-${item?.variant}`] : ['text-info'],
    );
  }

  get valueLabel(): string {
    const item = this.fieldConfig.valueToLabel?.find(item => item.value === this.value);
    return item?.label || item?.text || this.value;
  }
}
